const RELOAD_KEY = 'nrepo:chunk-reload';

/**
 * Wraps a React.lazy loader. A tab left open across a deploy still points at the old build's
 * chunk names, which no longer exist, so a failed import reloads the page once to pick up the
 * new build instead of showing the error page.
 */
export function reloadOnChunkError<T>(load: () => Promise<T>): () => Promise<T> {
  return async () => {
    try {
      const mod = await load();
      try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* storage blocked */ }
      return mod;
    } catch (err) {
      let reloaded = true;
      try {
        reloaded = sessionStorage.getItem(RELOAD_KEY) === '1';
        if (!reloaded) sessionStorage.setItem(RELOAD_KEY, '1');
      } catch { /* storage blocked: don't risk a reload loop */ }
      if (!reloaded) {
        window.location.reload();
        return new Promise<never>(() => {});
      }
      throw err;
    }
  };
}
